<template>
  <div class="row bg-white" :style="props.embedded ? 'height: 100%; display: flex; flex-direction: column;' : ''">
    <div class="col-12" :style="props.embedded ? 'flex: 1; min-height: 0; display: flex; flex-direction: column;' : ''">
      <div class="row gy-2"
        :style="props.embedded ? 'flex: 1; min-height: 0; display: flex; flex-direction: column;' : ''">

        <div v-if="!props.embedded" class="col-12">
          <!-- Filter bar -->
          <div class="dash-filterbar">
            <NSelect v-model:value="FILTERS.ELEMENT" :disabled="isLoading" :options="ELEMENT_OPTS"
              :theme-overrides="inputTheme" filterable clearable placeholder="Select commodity to view"
              :input-props="{ autocomplete: Math.random() }" class="dash-filterbar__select" size="small" />
            <div class="dash-filterbar__date">
              <span class="dash-filterbar__label">Start</span>
              <NDatePicker v-model:value="yearsView[0]" type="year" clearable :is-date-disabled="disableOutOfRange"
                :input-props="{ autocomplete: randomId }" class="dash-filterbar__datepicker" size="small" />
            </div>
            <div class="dash-filterbar__date">
              <span class="dash-filterbar__label">End</span>
              <NDatePicker v-model:value="yearsView[1]" type="year" clearable :is-date-disabled="disableOutOfRange"
                :input-props="{ autocomplete: randomId }" class="dash-filterbar__datepicker" size="small" />
            </div>
            <NButton size="small" :disabled="isDisabled" @click="getTableData()" color="#213ce5"
              style="background: linear-gradient(90deg, #213ce5, #2380f2); border: 1px solid transparent;"
              @mouseenter="e => e.currentTarget.style.border = '1px solid #00aeef'"
              @mouseleave="e => e.currentTarget.style.border = '1px solid transparent'">
              Search
            </NButton>
          </div>

          <!-- Action row -->
          <div class="dash-actions">
            <button class="dash-action-btn" :class="{ 'dash-action-btn--active': displayType === 'Table' }"
              @click="setType('Table')">
              <img :src="DDICONS.table" alt="" class="dash-action-btn__icon" />
              View as table
            </button>
            <button class="dash-action-btn" :class="{ 'dash-action-btn--active': displayType === 'Graph' }"
              @click="setType('Graph')">
              <img :src="DDICONS.graphic" alt="" class="dash-action-btn__icon" />
              View as Graphic
            </button>
            <button class="dash-action-btn" :class="{ 'dash-action-btn--active': displayType === 'All' }"
              @click="setType('All')">
              <img :src="DDICONS.graphTable" alt="" class="dash-action-btn__icon" />
              View Table &amp; Graphic
            </button>

            <!-- Export Applications -->
            <div class="relative inline-block"
              @focusout="e => { if (!e.currentTarget.contains(e.relatedTarget)) setTimeout(() => menuOpen = false, 100) }">
              <button class="dash-action-btn" :disabled="!isTableViewSearchable" @click="menuOpen = !menuOpen">
                <img :src="DDICONS.download" alt="" class="dash-action-btn__icon" />
                {{ displayType === 'Graph' ? 'Export Application Graphic' : 'Export Application Data' }}
              </button>
              <div v-show="menuOpen" class="split-menu" role="menu">
                <template v-if="displayType !== 'Graph'">
                  <button role="menuitem" @click="handleExportApplicationExcel">Export as Excel</button>
                  <button role="menuitem" @click="handleExportApplicationCSV">Export as CSV</button>
                </template>
                <template v-if="displayType !== 'Table'">
                  <button role="menuitem" @click="exportAs('png', false)">Export as PNG</button>
                  <button role="menuitem" @click="exportAs('svg', false)">Export as SVG</button>
                </template>
              </div>
            </div>

            <!-- Export Region -->
            <div class="relative inline-block"
              @focusout="e => { if (!e.currentTarget.contains(e.relatedTarget)) setTimeout(() => menuRegionOpen = false, 100) }">
              <button class="dash-action-btn" :disabled="!isTableViewSearchable"
                @click="menuRegionOpen = !menuRegionOpen">
                <img :src="DDICONS.download" alt="" class="dash-action-btn__icon" />
                {{ displayType === 'Graph' ? 'Export Region Graphic' : 'Export Region Data' }}
              </button>
              <div v-show="menuRegionOpen" class="split-menu" role="menu">
                <template v-if="displayType !== 'Graph'">
                  <button role="menuitem" @click="handleExportRegionExcel">Export as Excel</button>
                  <button role="menuitem" @click="handleExportRegionCSV">Export as CSV</button>
                </template>
                <template v-if="displayType !== 'Table'">
                  <button role="menuitem" @click="exportAs('png', true)">Export as PNG</button>
                  <button role="menuitem" @click="exportAs('svg', true)">Export as SVG</button>
                </template>
              </div>
            </div>

            <span class="dash-actions__disclaimer" @click="showDisclaimer = true"><em>Disclaimer</em></span>
          </div>
        </div>
        <div v-if="needsRefresh && !props.embedded" class="col-12">
          <div class="dash-empty-state">
            Select a commodity, product and countries, then click&nbsp;<strong>Refresh</strong>&nbsp;to load data.
          </div>
        </div>

        <div v-if="!needsRefresh && (displayType == 'Table' || displayType == 'All')" class="col-12">
          <h5 class="py-3 pb-0 header-title">Demand by Application</h5>
          <div class="table-scroll modern-scrollbar">
            <NDataTable :columns="columnsApplication" :data="tableDataApplications" :theme-overrides="tableTheme" />
          </div>
          <h5 class="py-3 pb-0 header-title" style="margin-top: 16px;">Demand by Region</h5>
          <div class="table-scroll modern-scrollbar">
            <NDataTable :columns="columnsCountries" :data="tableDataCountries" :theme-overrides="tableTheme" />
          </div>
        </div>
        <div v-if="(props.embedded || !needsRefresh) && (displayType == 'Graph' || displayType == 'All')" style="padding-top: 20px; margin-bottom: 10px;"
          class="row pe-0">
          <div class="col-12 col-lg-6">
            <div class="row gy-3 align-items-center">
              <div class="col-12 col-md-4">
                <NSelect v-model:value="graphView" :options="GRAPH_VIEW_OPTIONS" placeholder="Select graph view"
                  :theme-overrides="inputTheme" :input-props="{ autocomplete: Math.random() }" />
              </div>
              <div oncontextmenu="return false;" style="background-color: white;" ref="captureDiv">
                <div class="col-12" style="
                        background: url('https://driqq8crwypb5.cloudfront.net/articles/projectblue-data-dash-image.png') center/cover no-repeat;
                        background-color: rgba(255,255,255,0.8);
                        background-size: 60%;
                        padding: 20px;
                      ">
                  <DynamicChart :chartData="chartData" :options="options" :chart-type="graphView" />
                  <p :hidden="!showOnGraph" style="font-size: smaller;margin-left: 25px"><em>Source: Project Blue</em>
                  </p>
                  <p :hidden="!showOnGraph" style="font-size: smaller; margin-top: -15px;margin-left: 25px">
                    <em>Accessed:
                      {{
                        updatedDate }}</em>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="row gy-3 align-items-center">
              <div class="col-12 col-md-4">
                <NSelect v-model:value="graphViewCountries" :options="GRAPH_VIEW_OPTIONS" :theme-overrides="inputTheme"
                  placeholder="Select graph view" :input-props="{ autocomplete: Math.random() }" />
              </div>
              <div oncontextmenu="return false;" style="background-color: white;" ref="captureDivCountries">
                <div class="col-12" style="
                        background: url('https://driqq8crwypb5.cloudfront.net/articles/projectblue-data-dash-image.png') center/cover no-repeat;
                        background-color: rgba(255,255,255,0.8);
                        background-size: 60%;
                        padding: 20px;
                      ">
                  <DemandChart :chartData="chartDataCountries" :options="optionsCountries"
                    :chart-type="graphViewCountries" />
                  <p :hidden="!showOnGraphCountries" style="font-size: smaller;margin-left: 25px"><em>Source: Project
                      Blue.</em></p>
                  <p :hidden="!showOnGraphCountries" style="font-size: smaller; margin-top: -15px;margin-left: 25px">
                    <em>Accessed: {{
                      updatedDate }}</em>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p style="font-size: smaller;"><em>Source: Project Blue.</em></p>
        <p style="font-size: smaller; margin-top: -15px;"><em>Accessed: {{ updatedDate }}</em></p>
      </div>
    </div>
  </div>

  <NDrawer v-model:show="showDisclaimer" :width="400" :height="200" placement="right">
    <TermsAndConditions />
  </NDrawer>
</template>

<script setup>
import { ref, reactive, computed, watch, h, onMounted, onUnmounted, nextTick } from "vue";
import { NSelect, NDataTable, NDatePicker, NButton, NDrawer } from "naive-ui";
import DynamicChart from "@/components/DynamicChart.vue";
import DemandChart from "../../components/DemandChart.vue";
import { SUBSCRIPTION_INFO } from "@/composables/subscription";
import { getDemandData, demandData, products, countries, getCommodityProductsAndCountries } from "@/composables/marketData/datadashboards";
import * as htmlToImage from 'html-to-image';
import TermsAndConditions from "./TermsAndConditions.vue";
import { exportToCSV, exportToExcel } from "../../composables/marketData/datadashboards";
import { DDICONS } from "../../composables/generics";
import { logUserAction, USER_ACTIONS } from "@/composables/userLogs";
const randomId = ref(Math.random().toString());
const inputTheme = {
  peers: {
    InternalSelection: {
      borderHover: '1px solid #213ce5',
      borderFocus: '1px solid #213ce5',
      borderActive: '1px solid #213ce5',
      boxShadowFocus: '0 0 0 2px rgba(33, 60, 229, 0.2)',
      boxShadowActive: '0 0 0 2px rgba(33, 60, 229, 0.2)',
      boxShadowHover: 'none',
      caretColor: '#213ce5',
      arrowColorActive: '#213ce5',
      arrowColorHover: '#213ce5',
      color: '#fff',
      colorActive: '#ffffff',
      colorFocus: '#ffffff',
      fontFamily: "'GilroyMedium', sans-serif",
      fontSize: '11px !important',
    },
    InternalSelectMenu: {
      optionColorActive: 'rgba(33, 60, 229, 0.08)',
      optionColorActivePending: 'rgba(33, 60, 229, 0.12)',
      optionColorPending: 'rgba(33, 60, 229, 0.05)',
      optionTextColorActive: '#213ce5',
      optionTextColorChildActive: '#213ce5',
      optionCheckColor: '#213ce5',
      actionDividerColor: '#213ce5',
      loadingColor: '#213ce5',
      scrollbarColor: 'rgba(33, 60, 229, 0.3)',
      scrollbarColorHover: 'rgba(33, 60, 229, 0.5)',
      fontFamily: "'GilroyMedium', sans-serif",
      fontSize: '11px !important',
    }
  }
};
const props = defineProps({
  embedded: {
    type: Boolean,
    default: false
  },
  locked: { type: Boolean, default: false }
});
const tableTheme = {
  thColorSorting: 'transparent',
  thIconColorActive: '#213ce5',
  thIconColor: 'rgba(33, 60, 229, 0.3)',
  sorterColor: '#213ce5',
  sorterColorActive: '#213ce5',
};
const ELEMENT_OPTS = computed(() => {
  return SUBSCRIPTION_INFO?.dataElements?.map((nth) => {
    return {
      label: nth.name,
      value: nth.code,
    }
  })
});
const COUNTRY_OPTS = computed(() => {
  return (countries.value ?? []).map((nth) => {
    return {
      label: nth.name,
      value: nth.code,
    }
  })
});
const PRODUCT_OPTS = computed(() => {
  return (products.value ?? []).map((nth) => {
    return {
      label: nth.name,
      value: nth.code,
    }
  })
});

const FILTERS = reactive({
  SUBSCRIPTION: null,
  ELEMENT: null,
  SUB_ELEMENT: null,
  COMPANY: null,
  COUNTRY: null,
  ASSET: null
})
const GRAPH_VIEW_OPTIONS = ref([
  //{ label: 'Area Chart', value: 'stacked' },
  { label: 'Bar Chart', value: 'bar' },
  { label: 'Line Chart', value: 'line' },
  // { label: 'Stacked Chart', value: 'line' } - TODO
]);
const decimals = ref(0);
const DemandUom = ref("Demand");
const displayType = ref("Table");
const isSearch = ref(false);
const lastYearStart = ref(2015);
const lastYearEnd = ref(2035);
const showDisclaimer = ref(false);
const captureDiv = ref(null);
const captureDivCountries = ref(null);
const showOptions = ref(false);
const showOnGraph = ref(false);
const showOnGraphCountries = ref(false);
const isLoading = ref(true);
const needsRefresh = ref(false);
const isTableViewSearchable = computed(() => FILTERS.ELEMENT !== null)


function setType(type) {
  displayType.value = type;
  localStorage.setItem("displayTypeDemand", type);
  // Track display mode switch (Table, Graph, All)
  logUserAction(
    USER_ACTIONS.VIEW_DASHBOARD,
    `Switched Demand view to: "${type}" (Commodity: "${FILTERS.ELEMENT || 'N/A'}")`
  );
}


const graphView = ref(GRAPH_VIEW_OPTIONS.value[0].value);
const graphViewCountries = ref(GRAPH_VIEW_OPTIONS.value[0].value);
const yearsView = ref([
  (new Date(2015, 0)).getTime(),
  (new Date(2035, 0)).getTime(),
]);

const updatedDate = ref(new Date())

const showDatePickers = ref(false);
const handleClickOutside = (e) => {
  if (!e.target.closest('.relative.inline-block')) {
    menuOpen.value = false
    menuRegionOpen.value = false
  }
}
onMounted(async () => {
  document.addEventListener('click', handleClickOutside)
  FILTERS.ELEMENT = sessionStorage.getItem("element") ?? ELEMENT_OPTS.value[0].value;
  isLoading.value = false;
  displayType.value = localStorage.getItem("displayTypeDemand") ?? "Table";

  await initializeFilters(FILTERS.ELEMENT);

  await getTableData();
})
onUnmounted(() => document.removeEventListener('click', handleClickOutside))

const menuOpen = ref(false);
const menuRegionOpen = ref(false);
const menuOpenCountries = ref(false)

const exportAs = async (type, isCountry) => {
  menuOpen.value = false;
  menuRegionOpen.value = false;
  menuOpenCountries.value = false;
  const targetLabel = isCountry ? 'Region' : 'Application';
  // Track graphic download
  logUserAction(
    USER_ACTIONS.DOWNLOAD_DASHBOARD_GRAPH,
    `Exported Demand by ${targetLabel} graphic as ${type.toUpperCase()} (Commodity: "${FILTERS.ELEMENT || 'N/A'}")`
  );
  if (isCountry) {
    showOnGraphCountries.value = true;
  }
  else {
    showOnGraph.value = true;
  }
  await nextTick();
  if (type === 'svg') {
    downloadAsSvg(isCountry);
  } else {
    downloadAsPng(isCountry);
  }
}

const handleExportApplicationExcel = () => {
  menuOpen.value = false;
  exportToExcel(tableDataApplications.value, minYear.value, maxYear.value, 'Demand By Application.xlsx', 'demand-application');
  // Track spreadsheet download
  logUserAction(
    USER_ACTIONS.DOWNLOAD_DASHBOARD_DATA,
    `Exported Demand by Application data as Excel (Commodity: "${FILTERS.ELEMENT || 'N/A'}")`
  );
};

const handleExportApplicationCSV = () => {
  menuOpen.value = false;
  exportToCSV(tableDataApplications.value, minYear.value, maxYear.value, 'Demand By Application.csv', 'demand-application');
  // Track CSV download
  logUserAction(
    USER_ACTIONS.DOWNLOAD_DASHBOARD_DATA,
    `Exported Demand by Application data as CSV (Commodity: "${FILTERS.ELEMENT || 'N/A'}")`
  );
};

const handleExportRegionExcel = () => {
  menuRegionOpen.value = false;
  exportToExcel(tableDataCountries.value, minYear.value, maxYear.value, 'Demand By Region.xlsx', 'demand-region');
  // Track spreadsheet download
  logUserAction(
    USER_ACTIONS.DOWNLOAD_DASHBOARD_DATA,
    `Exported Demand by Region data as Excel (Commodity: "${FILTERS.ELEMENT || 'N/A'}")`
  );
};

const handleExportRegionCSV = () => {
  menuRegionOpen.value = false;
  exportToCSV(tableDataCountries.value, minYear.value, maxYear.value, 'Demand By Region.csv', 'demand-region');
  // Track CSV download
  logUserAction(
    USER_ACTIONS.DOWNLOAD_DASHBOARD_DATA,
    `Exported Demand by Region data as CSV (Commodity: "${FILTERS.ELEMENT || 'N/A'}")`
  );
};

const downloadAsSvg = (isCountry) => {
  htmlToImage.toSvg(isCountry ? captureDivCountries.value : captureDiv.value)
    .then(dataUrl => {
      const link = document.createElement("a");
      link.download = "capture.svg";
      link.href = dataUrl;
      link.click();
      showOptions.value = false;
      showOnGraphCountries.value = false;
      showOnGraph.value = false;
    });

}
const downloadAsPng = (isCountry) => {
  htmlToImage.toPng(isCountry ? captureDivCountries.value : captureDiv.value)
    .then(dataUrl => {
      const link = document.createElement("a");
      link.download = "capture.png";
      link.href = dataUrl;
      link.click();
      showOptions.value = false;
      showOnGraphCountries.value = false;
      showOnGraph.value = false;
    });
}

const minFilterYear = computed(() => {
  if (!demandData?.value[0].data) return 2015

  const allYears = demandData?.value[0].data?.flatMap(item => {
    let keys = Object.keys(item.yearlyData || {}).map(Number);
    return keys;
  });

  let minAllowedYears = demandData?.value[0].data.map(x => x.startYear);
  let minYear = Math.min(...minAllowedYears.filter(y => y != null));
  let min = allYears.length ? Math.min(...allYears) : null;
  return minYear == 'Infinity' ? min : min < minYear ? min : minYear;
})

const maxFilterYear = computed(() => {
  if (!demandData.value) return 2035

  const allYears = demandData?.value[0].data?.flatMap(item => {
    let keys = Object.keys(item.yearlyData || {}).map(Number)
    return keys
  })

  let maxAllowedYears = demandData?.value[0].data.map(x => x.endYear)
  let maxYear = Math.max(...maxAllowedYears.filter(y => y != null))

  let max = allYears.length ? Math.max(...allYears) : null

  return maxYear == '-Infinity' ? max : max > maxYear ? max : maxYear
})

const disableOutOfRange = (timestamp) => {
  const year = new Date(timestamp).getFullYear()

  const product = products.value?.[0];
  if (product) {
    return (
      year < product.startYear ||
      year > product.endYear
    );
  }

  return year < minFilterYear.value || year > maxFilterYear.value
}
const minYear = computed(() => {
  if (demandData?.value?.length != 2) return null

  const allYears = demandData.value[0].data.flatMap(item => {
    let keys = Object.keys(item.yearlyData || {}).map(Number);
    return keys;
  });

  let minAllowedYears = demandData.value[0].data.map(x => x.startYear);
  let minYear = Math.min(...minAllowedYears.filter(y => y != null));

  let min = allYears.length ? Math.min(...allYears) : null;
  return minYear == 'Infinity' ? min : min > minYear ? min : minYear;
})

const maxYear = computed(() => {
  if (demandData?.value?.length != 2) return null

  const allYears = demandData.value[0].data.flatMap(item => {
    let keys = Object.keys(item.yearlyData || {}).map(Number)
    return keys
  })

  let maxAllowedYears = demandData.value[0].data.map(x => x.endYear)
  let maxYear = Math.max(...maxAllowedYears.filter(y => y != null))

  let max = allYears.length ? Math.max(...allYears) : null

  return maxYear == '-Infinity' ? max : max > maxYear ? max : maxYear
})



const dataTypeUnits = reactive({
  Demand: '',
  Price: ''
})


const getUoms = () => {
  DemandUom.value = `Demand (${(demandData?.value[0]?.data[0]?.units ?? 'N/A')})`;
};

const tableDataCountries = computed(() => {
  if ((demandData.value || []).length == 0) {
    return [];
  }
  let data = demandData?.value[1]?.data

  const startYears = data.map(d => d.startYear);
  const endYears = data.map(d => d.endYear);

  let min = Math.min(...startYears);
  let max = Math.max(...endYears);

  lastYearStart.value = min == 0 ? 2015 : min;
  lastYearEnd.value = max == 0 ? 2035 : max;

  let parsedData = data.map(item => {
    const copy = { ...item };

    const years = copy.yearlyData;
    if (years && typeof years === 'object' && !Array.isArray(years)) {
      for (const [year, value] of Object.entries(years)) {
        copy[year] = value.toLocaleString('en', { minimumFractionDigits: decimals.value, maximumFractionDigits: decimals.value });
      }
    }
    delete copy.yearlyData;
    return copy;
  });
  return parsedData;
});

const tableDataApplications = computed(() => {

  if ((demandData.value || []).length == 0) {
    return [];
  }
  let data = demandData?.value[0]?.data || []
  const startYears = data.map(d => d.startYear);
  const endYears = data.map(d => d.endYear);

  let min = Math.min(...startYears);
  let max = Math.max(...endYears);

  lastYearStart.value = min == 0 ? 2015 : min;
  lastYearEnd.value = max == 0 ? 2035 : max;

  return data.map(item => {
    const copy = { ...item };

    const years = copy.yearlyData;
    if (years && typeof years === 'object' && !Array.isArray(years)) {
      for (const [year, value] of Object.entries(years)) {
        copy[year] = value.toLocaleString('en', { minimumFractionDigits: decimals.value, maximumFractionDigits: decimals.value });
      }
    }
    delete copy.yearlyData;

    return copy;
  })
})


const chartData = ref({
  labels: Array.from({ length: 21 }, (_, i) => (2015 + i).toString()),
  datasets: []
})

const chartDataCountries = ref({
  labels: Array.from({ length: 21 }, (_, i) => (2015 + i).toString()),
  datasets: []
})

const getChartData = () => {
  getUoms();

  const start = new Date(yearsView.value[0]).getFullYear();
  const end = new Date(yearsView.value[1]).getFullYear();

  // labels = [start, start+1, ..., end]
  const years = Array.from({ length: end - start + 1 }, (_, i) => start + i);

  // simple color palette (extend as needed)
  const colors = [
    '#213CE5', '#00AEEF', '#009A46', '#92D050', '#F0C302',
    '#FFED05', '#6801FF', '#9484FF', '#F25904', '#FC9860',
    '#F58231', '#911EB4', '#46F0F0', '#F032E6', '#D2F53C',
    '#FABEBE', '#008080', '#E6BEFF', '#AA6E28', '#FFFAC8',
    '#800000', '#AAFFC3', '#808000', '#FFD8B1', '#000080',
    '#808080', '#000000', '#9A6324', '#469990', '#DCBEFF',
    '#FFB6C1', '#40E0D0', '#6495ED', '#228B22', '#B8860B',
    '#A52A2A', '#5F9EA0', '#D2691E', '#708090', '#FF4500',
    '#ADFF2F', '#8A2BE2', '#20B2AA', '#FFD700', '#B22222',
    '#7FFF00', '#FF69B4', '#BA55D3', '#00CED1', '#DAA520'
  ];
  const colorFor = i => colors[i % colors.length];

  const datasets = (demandData?.value[0]?.data || [])
    .slice()
    .map((item, idx) => {
      const yearly = item.yearlyData || {}

      const data = years.map(y => {
        const v = yearly[String(y)]
        return v === undefined || v === null ? null : Number(v)
      })
      return {
        label: item.applicationDemand,
        data,
        borderColor: colorFor(idx),
        backgroundColor: colorFor(idx),
        borderWidth: 2,
        yAxisID: 'yLeft',
        fill: true,
        stacked: false,
        type: 'line',
        order: idx
      };
    });

  chartData.value.labels = years;
  chartData.value.datasets = datasets;
};

const getChartDataCountries = () => {
  getUoms();

  const start = new Date(yearsView.value[0]).getFullYear();
  const end = new Date(yearsView.value[1]).getFullYear();

  // labels = [start, start+1, ..., end]
  const years = Array.from({ length: end - start + 1 }, (_, i) => start + i);

  // simple color palette (extend as needed)
  const colors = [
    '#213CE5', '#00AEEF', '#009A46', '#92D050', '#F0C302',
    '#FFED05', '#6801FF', '#9484FF', '#F25904', '#FC9860',
    '#F58231', '#911EB4', '#46F0F0', '#F032E6', '#D2F53C',
    '#FABEBE', '#008080', '#E6BEFF', '#AA6E28', '#FFFAC8',
    '#800000', '#AAFFC3', '#808000', '#FFD8B1', '#000080',
    '#808080', '#000000', '#9A6324', '#469990', '#DCBEFF',
    '#FFB6C1', '#40E0D0', '#6495ED', '#228B22', '#B8860B',
    '#A52A2A', '#5F9EA0', '#D2691E', '#708090', '#FF4500',
    '#ADFF2F', '#8A2BE2', '#20B2AA', '#FFD700', '#B22222',
    '#7FFF00', '#FF69B4', '#BA55D3', '#00CED1', '#DAA520'
  ];
  const colorFor = i => colors[i % colors.length];

  const datasets = (demandData?.value[1]?.data || [])
    .slice()
    .map((item, idx) => {
      const yearly = item.yearlyData || {}

      const data = years.map(y => {
        const v = yearly[String(y)]
        return v === undefined || v === null ? null : Number(v)
      })

      return {
        label: item.country,
        data,
        borderColor: colorFor(idx),
        backgroundColor: colorFor(idx),
        borderWidth: 2,
        yAxisID: 'yLeft',
        fill: true,
        stacked: false,
        type: 'line',
        order: idx
      };
    });

  chartDataCountries.value.labels = years;
  chartDataCountries.value.datasets = datasets;
};

const columnsApplication = computed(() => {
  const start = lastYearStart.value;
  const end = lastYearEnd.value;

  let columnStart = minYear.value;
  let columnEnd = maxYear.value;

  if(FILTERS.ELEMENT){
    columnStart = new Date(yearsView.value[0]).getFullYear();
    columnEnd = new Date(yearsView.value[1]).getFullYear();
  }

  let response = [
    /*{
      title: () =>
        h('div', { style: 'display: flex; align-items: flex-end; gap: 12px;' }, [
          !showDatePickers.value
            ? h(NButton, {
              type: 'default',
              onClick: () => (showDatePickers.value = true),
              color: '#00213b',
            }, { default: () => 'Filter Period' })
            : [
              // Start Year Picker with Label
              h('div', { style: 'display: flex; flex-direction: column;' }, [
                h('label', { style: 'font-size: 12px; margin-bottom: 2px;' }, 'Start'),
                h(NDatePicker, {
                  value: yearsView.value[0],
                  'onUpdate:value': (val) => (yearsView.value[0] = val),
                  type: 'year',
                  inputProps: { autocomplete: Math.random().toString() },
                  class: 'd-inline-block',
                  isDateDisabled: (timestamp) => {
                    const year = new Date(timestamp).getFullYear();
                    return year < start || year > end;
                  },
                })
              ]),

              // End Year Picker with Label
              h('div', { style: 'display: flex; flex-direction: column;' }, [
                h('label', { style: 'font-size: 12px; margin-bottom: 2px;' }, 'End'),
                h(NDatePicker, {
                  value: yearsView.value[1],
                  'onUpdate:value': (val) => (yearsView.value[1] = val),
                  type: 'year',
                  inputProps: { autocomplete: Math.random().toString() },
                  class: 'd-inline-block',
                  isDateDisabled: (timestamp) => {
                    const year = new Date(timestamp).getFullYear();
                    return year < start || year > end;
                  },
                })
              ]),

              // Aligned Filter Button
              h('div', { style: 'display: flex; flex-direction: column;' }, [
                h('label', { style: 'visibility: hidden; height: 20px;' }, 'Filter'), // Invisible label for spacing
                h(NButton, {
                  type: 'info',
                  disabled: isDisabled.value,
                  onClick: getTableData,
                  color: '#00213b',
                }, { default: () => 'Refresh' })
              ])
            ]
        ]),
      key: 'applicationDemand',
      width: '150px',
      fixed: 'left'
    },*/
    {
      title: "Application Demand",
      key: 'applicationDemand',
      width: '250px',
      fixed: 'left'
    },
    {
      title: 'Units',
      key: 'units',
      width: '100px',
      fixed: 'left',
    },
    ...Array.from({ length: columnEnd - columnStart + 1 }, (_, i) => ({
      title: `${columnStart + i}`,
      key: `${columnStart + i}`,
      width: '110px',
      align: 'right'
    }))
  ];
  lastYearStart.value = isSearch.value ? new Date(yearsView.value[0]).getFullYear() : lastYearStart.value;
  lastYearEnd.value = isSearch.value ? new Date(yearsView.value[1]).getFullYear() : lastYearEnd.value;
  isSearch.value = false;
  response.forEach(col => {
    col.sortable = true;
    col.sortOrder = 'asc'; // start with ascending
    col.sorter = (a, b, order) => {
      const valA = a[col.key].toLocaleString().replace(',', '');
      const valB = b[col.key].toLocaleString().replace(',', '');

      let result;
      if (!isNaN(valA) && !isNaN(valB)) {
        result = Number(valA) - Number(valB);
      } else {
        result = String(valA).localeCompare(String(valB));
      }

      // Apply sort direction
      return order === 'desc' ? -result : result;
    };
  });
  return response;
});

const columnsCountries = computed(() => {
  const start = lastYearStart.value;
  const end = lastYearEnd.value;

  let columnStart = minYear.value;
  let columnEnd = maxYear.value;

  if(FILTERS.ELEMENT){
    columnStart = new Date(yearsView.value[0]).getFullYear();
    columnEnd = new Date(yearsView.value[1]).getFullYear();
  }

  let response = [
    {
      title: "Country",
      key: 'country',
      width: '250px',
      fixed: 'left'
    },
    {
      title: 'Units',
      key: 'units',
      width: '100px',
      fixed: 'left',
    },
    ...Array.from({ length: columnEnd - columnStart + 1 }, (_, i) => ({
      title: `${columnStart + i}`,
      key: `${columnStart + i}`,
      width: '110px',
      align: 'right',
    }))
  ];
  lastYearStart.value = isSearch.value ? new Date(yearsView.value[0]).getFullYear() : lastYearStart.value;
  lastYearEnd.value = isSearch.value ? new Date(yearsView.value[1]).getFullYear() : lastYearEnd.value;
  isSearch.value = false;
  response.forEach(col => {
    col.sortable = true;
    col.sortOrder = 'asc'; // start with ascending
    col.sorter = (a, b, order) => {
      const valA = a[col.key].toLocaleString().replace(',', '');
      const valB = b[col.key].toLocaleString().replace(',', '');

      let result;
      if (!isNaN(valA) && !isNaN(valB)) {
        result = Number(valA) - Number(valB);
      } else {
        result = String(valA).localeCompare(String(valB));
      }

      // Apply sort direction
      return order === 'desc' ? -result : result;
    };
  });
  return response;
});


const isDisabled = computed(() => { FILTERS?.ELEMENT == undefined || FILTERS?.PRODUCT == undefined || FILTERS?.COUNTRY == undefined; })

const getTableData = async () => {
  needsRefresh.value = false;
  graphView.value = null;
  graphViewCountries.value = null;
  //demandData.value = null;

  const startYearNum = new Date(yearsView.value[0]).getFullYear();
  const endYearNum = new Date(yearsView.value[1]).getFullYear();

  // Track search query execution
  logUserAction(
    USER_ACTIONS.SEARCH_DASHBOARD,
    `Searched Demand: Commodity="${FILTERS.ELEMENT || 'N/A'}", Product="${FILTERS.PRODUCT || 'All'}", Years=${startYearNum}-${endYearNum}`
  );

  await getDemandData(FILTERS.ELEMENT, FILTERS.PRODUCT, FILTERS.COUNTRY, startYearNum, endYearNum);

  if (!FILTERS.ELEMENT) {
    const start = minYear.value;
    const end = maxYear.value;

    yearsView.value = [
      (new Date((start == 'Infinity' || start == null ? 2015 : start), 0)).getTime(),
      (new Date((end == '-Infinity' || end == null ? 2035 : end), 0)).getTime(),
    ];
  }

  decimals.value = demandData.value[0].data[0]?.decimalPlaces
    ?? 1;

  getChartData();
  getChartDataCountries();
  graphView.value = GRAPH_VIEW_OPTIONS.value[0].value; // Reset to default graph view
  graphViewCountries.value = GRAPH_VIEW_OPTIONS.value[0].value; // Reset to default graph view
  isSearch.value = true;
}

const options = ref({
  responsive: true,
  maintainAspectRatio: false,
  width: '100%',
  height: 700,
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        boxWidth: 20,
        padding: 15,
        color: 'black'
      },
      onClick: () => { return }
    }
  },
  scales: {
    x: {
      stacked: true,
      type: 'category',
      ticks: {
        color: 'black',
      },
      grid: { drawOnChartArea: false }
    },
    yLeft: {
      stacked: true,
      min: 0,
      grid: { drawOnChartArea: false },
      title: {
        display: true,
        text: `${DemandUom.value}`,
        font: { size: 16 },
        color: 'black'
      },
      ticks: {
        color: 'black',
        callback: (value) =>
          Number(value).toLocaleString('en-US', {
            minimumFractionDigits: decimals.value,
            maximumFractionDigits: decimals.value
          })

      }
    },
  }
});

const optionsCountries = ref({
  responsive: true,
  maintainAspectRatio: false,
  width: '100%',
  height: 700,
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        boxWidth: 20,
        padding: 15,
        color: 'black'
      },
      onClick: (e, legendItem, legend) => {
        const chart = legend.chart;
        const datasetIndex = legendItem.datasetIndex;

        // toggle visibility (default behavior)
        const meta = chart.getDatasetMeta(datasetIndex);
        meta.hidden = !meta.hidden;

        chart.update();
      }
    }
  },
  scales: {
    x: {
      stacked: true,
      type: 'category',
      ticks: {
        color: 'black',
      },
      grid: { drawOnChartArea: false }
    },
    yLeft: {
      stacked: true,
      min: 0,
      grid: { drawOnChartArea: false },
      title: {
        display: true,
        text: `${DemandUom.value}`,
        font: { size: 16 },
        color: 'black'
      },
      ticks: {
        color: 'black',
        callback: (value) =>
          Number(value).toLocaleString('en-US', {
            minimumFractionDigits: decimals.value,
            maximumFractionDigits: decimals.value
          })

      }
    },
  }
});

watch([DemandUom], () => {
  options.value.scales.yLeft.title.text = `${DemandUom.value}`;
  optionsCountries.value.scales.yLeft.title.text = `${DemandUom.value}`;
});


watch(!FILTERS.ELEMENT, () => {
  //getTableData();
  yearsView.value = [
    (new Date(2015, 0)).getTime(),
    (new Date(2035, 0)).getTime(),
  ];
  showDatePickers.value = false;
}, { immediate: true })

watch(
  () => FILTERS.ELEMENT,
  async (newVal) => {
    await initializeFilters(newVal);
  }
);

watch(
  () => FILTERS.COUNTRY,
  () => {
    if (FILTERS.COUNTRY.length > 4) {
      FILTERS.COUNTRY = FILTERS.COUNTRY.slice(0, 4);
      window.$message.warning("You may only select up to 4 countries at a time.");
    }
  }
);

watch(graphView, () => {
  if (chartData.value?.datasets?.length == 0) {
    return;
  }
  
  if (graphView.value === 'bar') {
    chartData.value.datasets.forEach(ds => {
      ds.type = 'bar'
      ds.stack = '1' // all go into same stack
    })

    options.value.scales.yLeft.stacked = true
  }

  else if (graphView.value === 'line') {
    chartData.value.datasets.forEach(ds => {
      ds.type = 'line'
      ds.fill = false
      delete ds.stack // remove stacking
    })

    options.value.scales.yLeft.stacked = false
  }

  else {
    chartData.value.datasets.forEach(ds => {
      ds.type = 'line'
      ds.fill = true
      ds.stack = '1' // stack lines into one group
    })

    options.value.scales.yLeft.stacked = true
  }

});

watch(graphViewCountries, () => {
  if (chartDataCountries.value?.datasets?.length == 0) {
    return;
  }
  //options.value.scales.yLeft.offset = false;
  //options.value.scales.yLeft.grid.offset = false;

  if (graphViewCountries.value === 'bar') {
    chartDataCountries.value.datasets.forEach(ds => {
      ds.type = 'bar'
      ds.stack = '1' // all go into same stack
    })

    optionsCountries.value.scales.yLeft.stacked = true
  }

  else if (graphViewCountries.value === 'line') {
    chartDataCountries.value.datasets.forEach(ds => {
      ds.type = 'line'
      ds.fill = false
      delete ds.stack // remove stacking
    })

    optionsCountries.value.scales.yLeft.stacked = false
  }

  else {
    chartDataCountries.value.datasets.forEach(ds => {
      ds.type = 'line'
      ds.fill = true
      ds.stack = '1' // stack lines into one group
    })

    optionsCountries.value.scales.yLeft.stacked = true
  }
});

const initializeFilters = async (element) => {
  FILTERS.COUNTRY = [];
  demandData.value = [];
  needsRefresh.value = true;

  await getCommodityProductsAndCountries(element, "Regional");
  const product = products.value?.[0];

  if (product) {
    yearsView.value = [
      new Date(product.startYear, 0).getTime(),
      new Date(product.endYear, 0).getTime()
    ];
  }

  sessionStorage.setItem("element", element);
};

</script>

<style lang="scss">
.header-title {
  font-size: 1rem;
  font-weight: 700;
  color: #000;
  font-family: 'GilroyBold', sans-serif;
}

.dash-empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  color: #000;
  font-size: 12px !important;
  font-weight: 400 !important;
  font-family: 'GilroyMedium', sans-serif;
  text-align: center;
  background: #f2f2f2;
}

/* ── Filter bar ── */
.dash-filterbar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background: #f2f2f2;
  flex-wrap: wrap;

  .n-date-picker {
    .n-input {
      --n-border: 1px solid #e0e0e6 !important;
      --n-border-hover: 1px solid #2184ff !important;
      --n-border-focus: 1px solid #2184ff !important;
      --n-border-active: 1px solid #2184ff !important;
      --n-box-shadow-focus: 0 0 0 2px rgba(33, 132, 255, 0.2) !important;
      --n-caret-color: #2184ff !important;
    }

    .n-date-panel {
      --n-item-color-active: #2184ff !important;
      --n-item-text-color-active: #fff !important;
      --n-item-color-hover: rgba(33, 132, 255, 0.1) !important;
    }
  }

  /* Select border overrides */
  .n-base-selection {
    --n-border: 1px solid #e0e0e6 !important;
    --n-border-hover: 1px solid #2184ff !important;
    --n-border-focus: 1px solid #2184ff !important;
    --n-border-active: 1px solid #2184ff !important;
    --n-box-shadow-focus: 0 0 0 2px rgba(33, 132, 255, 0.2) !important;
    --n-caret-color: #2184ff !important;
    --n-arrow-color-hover: #2184ff !important;
    --n-arrow-color-active: #2184ff !important;
  }
}

.dash-filterbar__select {
  width: 200px;
}

.dash-filterbar__date {
  display: flex;
  align-items: center;
  gap: 6px;
}

.dash-filterbar__label {
  font-size: 12px;
  color: #000;
  white-space: nowrap;
}

.dash-filterbar__datepicker {
  width: 110px;
}

/* ── Action row ── */
.dash-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.5rem;
  background: #f2f2f2;
  flex-wrap: wrap;
  row-gap: 0.25rem;
}

.dash-action-btn {
  flex-shrink: 0;
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-size: 12px;
  color: #000;
  cursor: pointer;
  padding: 4px 10px 4px 4px;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;

  &--active {
    color: #2184ff;
    font-weight: 600;
    text-decoration: underline;
  }

  &:hover:not(&--active):not(:disabled) {
    color: #2184ff;
    font-weight: 600;
    text-decoration: underline;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}

.dash-action-btn__icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: block;
  border-radius: 50%;
}

.dash-actions__disclaimer {
  margin-left: auto;
  font-size: 11px;
  color: #9dabaf;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.n-date-panel-actions__suffix>.n-button {
  display: none !important;
}

p {
  font-size: 14px !important;
  line-height: 1.625 !important;
  font-weight: 400 !important;
}

.chart-legend li {
  text-transform: none !important;
  color: red !important;
}

.split-btn {
  display: inline-flex;
  border-radius: 3px;
  overflow: hidden;
  height: 34px;
}

.primary {
  background: #00213b;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

.toggle {
  background: #e5e7eb;
  border: none;
  cursor: pointer;
}

.caret {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid currentColor;
}

.split-menu {
  position: absolute;
  margin-top: 6px;
  width: 110px;
  background: white;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  z-index: 1000;
}

.split-menu button {
  width: 100%;
  background: transparent;
  border: 0;
  text-align: left;
  cursor: pointer;
  font-size: 12px !important;
}

.split-menu button:hover {
  background: rgba(37, 99, 235, 0.08);
}

//.active {
//  background-color: white !important;
//  /* secondary color */
//  color: #00213b !important;
//  font-weight: bold;
//  border: 1px solid #00213b !important;
//}

.input-wrapper {
  position: relative;
  /* anchor for absolute toast */
  width: 100%;
}

.p-toast {
  position: absolute;
  top: calc(100% - 110px);
  /* appear just under textbox */
  left: 0;

  background: #fff8e5;
  color: #5f4b00;
  border-left: 4px solid #f6c343;
  padding: 10px 14px;
  border-radius: 6px;
  font-size: 14px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  max-width: 100%;

  white-space: normal;
  z-index: 9999;

  opacity: 0;
  transform: translateY(-5px);
  animation: toastFade 4.5s ease forwards;
}

@keyframes toastFade {
  0% {
    opacity: 0;
    transform: translateY(-5px);
  }

  10% {
    opacity: 1;
    transform: translateY(0);
  }

  80% {
    opacity: 1;
    transform: translateY(0);
  }

  100% {
    opacity: 0;
    transform: translateY(-5px);
  }
}

.switch-large {
  --n-height: 280px;
  --n-rail-border-radius: 14px;
  --n-rail-padding: 2px;
}

.child-header-row .n-data-table-td {
  font-weight: bold;
  background-color: #f5f5f5;
  font-size: small !important;
}

.child-row .n-data-table-td {
  background-color: #f5f5f5;
}

.n-data-table-td {
  white-space: nowrap !important;
}

.table-scroll.modern-scrollbar {
  overflow-x: auto;
  overflow-y: visible;
  height: auto;
}
</style>